import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import {Fieldset} from 'primereact/fieldset';
import Translate from '../../shared/language/Translate';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from '../../shared/component/form/AvField';
import PurchaseRequisitionService from '../../shared/service/PurchaseRequisitionService';
import SupplierService from '../../shared/service/SupplierService';
import NumberFormat from 'react-number-format';
import {toast} from 'react-toastify';
import {PRODUCT_UNIT} from '../../shared/utils/Constants';
import {normalizeItem} from '../purchaserequisition/PurchaseRequisitionUtils';
import DateInput from '../../shared/component/form/DateInput';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import '../../shared/styles/SettingsPage.css';

dayjs.extend(customParseFormat);

const requiredMark = <span style={{color: 'red'}}> (*)</span>;

export default class PurchaseRequisitionItemMobileSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            supplierList: [],
            costAlternativesExpanded: false
        };
        this.purchaseRequisitionService = new PurchaseRequisitionService();
        this.supplierService = new SupplierService();
    }

    componentDidMount() {
        this.supplierService.findAll().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({supplierList: response});
            }
        });
    }

    setData = (data) => {
        const item = Object.assign({}, data);
        if (this.props.deliveryMode === true
            && (item.deliveredBoxCount == null || item.deliveredBoxCount === '')) {
            item.deliveredBoxCount = 1;
        }
        this.setState({
            item,
            costAlternativesExpanded: false
        }, () => {
            if (!this.isReadOnly()) {
                this.focusBarcodeInput();
            }
            if (this.props.deliveryMode === true) {
                this.updateDeliveryCalcFields({});
            }
        });
    };

    isReadOnly = () => this.props.readOnly === true;

    focusBarcodeInput = () => {
        if (this.isReadOnly()) {
            return;
        }
        setTimeout(() => {
            if (this.barcodeRef) {
                this.barcodeRef.focus();
            }
        }, 100);
    };

    resolveSupplier = (supplierId) => {
        if (GeneralUtils.isNullOrEmpty(supplierId)) {
            return null;
        }
        const normalizedId = Number(supplierId);
        const supplier = (this.state.supplierList || []).find(s =>
            Number(s.id) === normalizedId || s.id == supplierId
        );
        if (!supplier) {
            return null;
        }
        return {
            id: supplier.id,
            name: supplier.name,
            bssId: supplier.bssId || supplier.deposSupplierBssId || null
        };
    };

    applySupplierFields = (item, supplierId, supplierName, supplierBssId) => ({
        ...item,
        supplierId,
        supplierName,
        supplierBssId,
        currentSupplierId: supplierId,
        currentSupplierName: supplierName
    });

    applyLookupToItem = (lookup) => {
        const supplier = this.resolveSupplier(lookup.currentSupplierId || lookup.supplierId);
        const supplierId = lookup.supplierId ?? lookup.currentSupplierId ?? supplier?.id ?? null;
        const supplierName = lookup.supplierName ?? lookup.currentSupplierName ?? supplier?.name ?? null;
        const supplierBssId = lookup.supplierBssId ?? supplier?.bssId ?? null;
        const isDelivery = this.props.deliveryMode === true;
        const item = this.applySupplierFields({
            ...this.state.item,
            barcode: lookup.barcode,
            itemName: lookup.itemName,
            itemBssId: lookup.itemBssId,
            itemUnitMeasure: lookup.itemUnitMeasure,
            itemSize: lookup.itemSize,
            boxSize: isDelivery ? null : lookup.boxSize,
            currentCost: isDelivery ? null : lookup.currentCost,
            minStock: isDelivery ? null : lookup.minStock,
            maxStock: isDelivery ? null : lookup.maxStock,
            recommendedOrderAmount: isDelivery ? null : lookup.recommendedOrderAmount,
            actualOrderAmount: isDelivery ? null : lookup.actualOrderAmount,
            currentStock: isDelivery ? null : lookup.currentStock,
            deliveredBoxCount: isDelivery ? 1 : this.state.item.deliveredBoxCount,
            damagedQuantity: isDelivery ? null : this.state.item.damagedQuantity
        }, supplierId, supplierName, supplierBssId);
        this.setState({item}, () => {
            if (isDelivery) {
                this.updateDeliveryCalcFields({});
            }
        });
    };

    findByBarcode = () => {
        if (this.isReadOnly()) {
            return;
        }
        const barcode = this.state.item?.barcode;
        if (GeneralUtils.isNullOrEmpty(barcode)) {
            return;
        }
        this.purchaseRequisitionService.findProductByBarcode(barcode).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.applyLookupToItem(response);
            } else {
                toast.warn('Barcode not Found!');
            }
        });
    };

    __handleChange = (e) => {
        if (this.isReadOnly()) {
            return;
        }
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const name = e.target.name;
        let parsedValue = value;
        if (name === 'barcode' && value != null) {
            parsedValue = value.toString().replace(/[^0-9]/g, '');
        }
        this.setState(prev => ({
            item: {...prev.item, [name]: parsedValue}
        }));
    };

    __handleSupplierChange = (e) => {
        if (this.isReadOnly()) {
            return;
        }
        const rawValue = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const supplierId = GeneralUtils.isNullOrEmpty(rawValue) ? null : Number(rawValue);
        const supplier = this.resolveSupplier(supplierId);
        this.setState(prev => ({
            item: this.applySupplierFields(
                prev.item,
                supplierId,
                supplier?.name ?? null,
                supplier?.bssId ?? null
            )
        }));
    };

    _handleEnterKeyDown = (e) => {
        if (e.target.name === 'barcode') {
            const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'];
            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
            if (!isDigit && !allowedKeys.includes(e.key) && !e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                return;
            }
        }
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            this.findByBarcode();
            if (this.barcodeRef) {
                this.barcodeRef.focus();
            }
        }
    };

    _handleEnterInput = (e) => {
        if (e.nativeEvent.inputType === 'insertLineBreak') {
            e.preventDefault();
            this.findByBarcode();
            if (this.barcodeRef) {
                this.barcodeRef.focus();
            }
        }
    };

    validateItem = (item) => {
        if (GeneralUtils.isNullOrEmpty(item.barcode)) {
            toast.warn('Barcode is required');
            return false;
        }
        if (this.props.deliveryMode) {
            const itemQty = item.deliveredBoxCount;
            const boxQuantity = item.boxSize;
            if (itemQty == null || String(itemQty).trim() === '') {
                toast.warn('Number of Boxes is required');
                return false;
            }
            const itemQtyNumber = Number(itemQty);
            if (Number.isNaN(itemQtyNumber) || itemQtyNumber < 0) {
                toast.warn('Number of Boxes must be a valid number');
                return false;
            }
            if (boxQuantity == null || String(boxQuantity).trim() === '') {
                toast.warn('Units per Box is required');
                return false;
            }
            const boxQuantityNumber = Number(boxQuantity);
            if (Number.isNaN(boxQuantityNumber) || boxQuantityNumber < 0) {
                toast.warn('Units per Box must be a valid number');
                return false;
            }
            const deliveryQty = itemQtyNumber * boxQuantityNumber;
            item.actualOrderAmount = deliveryQty;
            if (item.damagedQuantity != null && String(item.damagedQuantity).trim() !== '') {
                const damagedNumber = Number(item.damagedQuantity);
                if (Number.isNaN(damagedNumber) || damagedNumber < 0) {
                    toast.warn('Waste Quantity must be a valid number');
                    return false;
                }
                if (damagedNumber > deliveryQty) {
                    toast.warn('Waste Quantity cannot be greater than Total Quantity');
                    return false;
                }
            }
            return true;
        }
        if (this.props.webPopup) {
            const supplierId = item.supplierId ?? item.currentSupplierId;
            if (GeneralUtils.isNullOrEmpty(supplierId)) {
                toast.warn('Supplier is required');
                return false;
            }
            if (GeneralUtils.isNullOrEmpty(item.itemName)) {
                toast.warn('Product Name is required');
                return false;
            }
        }
        const actualOrderAmount = item.actualOrderAmount;
        if (actualOrderAmount == null || String(actualOrderAmount).trim() === '') {
            toast.warn('Actual Order Amount is required');
            return false;
        }
        return true;
    };

    handleSave = (closeAfter = true) => {
        const item = normalizeItem({...this.state.item});
        if (!this.validateItem(item)) {
            return;
        }
        if (closeAfter) {
            this.props.saveItem(item);
        } else {
            this.props.saveItemAndNext(item);
        }
    };

    applyAlternativeSupplier = (alternative) => {
        if (!alternative || this.isReadOnly()) {
            return;
        }
        this.setState(prev => ({
            item: this.applySupplierFields(
                {
                    ...prev.item,
                    currentCost: alternative.unitCost,
                    cheaperCostAvailable: false,
                    costAlternatives: []
                },
                alternative.supplierId ?? null,
                alternative.supplierName ?? null,
                alternative.supplierBssId ?? null
            )
        }));
    };

    formatMoney = (value) => {
        if (value == null || value === '') {
            return '-';
        }
        const number = Number(value);
        if (Number.isNaN(number)) {
            return value;
        }
        return `£${number.toFixed(2)}`;
    };

    renderCostAlternatives(item) {
        if (!this.props.webPopup || !this.props.showCostAlternatives || !item?.cheaperCostAvailable) {
            return null;
        }
        const alternatives = item.costAlternatives || [];
        if (alternatives.length === 0) {
            return null;
        }
        const expanded = this.state.costAlternativesExpanded === true;
        const optionLabel = alternatives.length === 1
            ? '1 cheaper supplier option available'
            : `${alternatives.length} cheaper supplier options available`;

        return (
            <div className="purchase-requisition-item-form__section purchase-requisition-item-form__section--alternatives">
                <div className="purchase-requisition-cost-alternatives">
                    <button
                        type="button"
                        className="purchase-requisition-cost-alternatives__toggle"
                        onClick={() => this.setState(prev => ({
                            costAlternativesExpanded: !prev.costAlternativesExpanded
                        }))}
                        aria-expanded={expanded}
                    >
                        <i className={`pi ${expanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} aria-hidden="true"/>
                        <span className="purchase-requisition-cost-alternatives__toggle-text">
                            {expanded ? 'Hide cheaper supplier options' : optionLabel}
                        </span>
                    </button>
                    {expanded &&
                        <div className="purchase-requisition-cost-alternatives__table-wrap">
                        <table className="purchase-requisition-cost-alternatives__table">
                            <thead>
                                <tr>
                                    <th className="purchase-requisition-cost-alternatives__supplier-col">Supplier</th>
                                    <th className="purchase-requisition-cost-alternatives__cost-col">Unit Cost</th>
                                    {!this.isReadOnly() &&
                                        <th className="purchase-requisition-cost-alternatives__action-col"/>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {alternatives.map((alternative, index) => (
                                    <tr key={`${alternative.supplierId || alternative.supplierName || index}`}>
                                        <td className="purchase-requisition-cost-alternatives__supplier-col">
                                            {alternative.supplierName || '-'}
                                        </td>
                                        <td className="purchase-requisition-cost-alternatives__cost purchase-requisition-cost-alternatives__cost-col">
                                            {this.formatMoney(alternative.unitCost)}
                                        </td>
                                        {!this.isReadOnly() &&
                                            <td className="purchase-requisition-cost-alternatives__action purchase-requisition-cost-alternatives__action-col">
                                                <Button
                                                    color="outline-primary"
                                                    size="sm"
                                                    className="settings-page__btn--action"
                                                    onClick={() => this.applyAlternativeSupplier(alternative)}
                                                >
                                                    Select
                                                </Button>
                                            </td>
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
                </div>
            </div>
        );
    }

    isFieldDisabled = (fieldDisabled = false) => this.isReadOnly() || fieldDisabled;

    renderNumberField = (name, label, fieldDisabled = false, required = false) => {
        const disabled = this.isFieldDisabled(fieldDisabled);
        const readonlyClass = disabled
            ? ' purchase-requisition-item-form__input--readonly'
            : ' purchase-requisition-item-form__input--editable';
        const rawValue = this.state.item[name];
        if (disabled && (rawValue == null || rawValue === '')) {
            return (
                <AvGroup>
                    <Label for={name}>
                        {label}
                        {required && requiredMark}
                    </Label>
                    <input
                        type="text"
                        className={`form-control${readonlyClass}`}
                        value="—"
                        disabled={true}
                        readOnly={true}
                    />
                </AvGroup>
            );
        }
        return (
            <AvGroup>
                <Label for={name}>
                    {label}
                    {required && requiredMark}
                </Label>
                <NumberFormat
                    value={rawValue}
                    className={`number-format-input form-control${readonlyClass}`}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={false}
                    onValueChange={(values) => {
                        if (disabled) {
                            return;
                        }
                        this.setState(prev => ({
                            item: {...prev.item, [name]: values.value}
                        }));
                    }}
                    disabled={disabled}
                />
            </AvGroup>
        );
    };

    renderFooterButtons() {
        if (this.isReadOnly()) {
            return (
                <Button
                    color="outline-primary"
                    className="settings-page__btn--action"
                    onClick={this.props.closeItemDialog}
                >
                    Close
                </Button>
            );
        }
        return (
            <>
                <Button
                    color="outline-primary"
                    className="settings-page__btn--action"
                    onClick={() => this.handleSave(true)}
                >
                    Save
                </Button>
                <Button
                    color="outline-primary"
                    className="settings-page__btn--action"
                    onClick={() => this.handleSave(false)}
                >
                    Save &amp; Next
                </Button>
                <Button
                    color="outline-primary"
                    className="settings-page__btn--action"
                    onClick={this.props.closeItemDialog}
                >
                    Close
                </Button>
            </>
        );
    }

    renderFooter() {
        if (this.props.webPopup) {
            return (
                <div className="purchase-requisition-item-form__footer">
                    <div className="settings-page__toolbar settings-page__toolbar--end settings-page__toolbar--equal-height">
                        {this.renderFooterButtons()}
                    </div>
                </div>
            );
        }

        return (
            <div className="mobile-fixed-footer">
                <div className="mobile-fixed-footer-inner">
                    <Button
                        color="outline-primary"
                        style={{marginRight: '5px', height: '30px', width: '110px'}}
                        onClick={() => this.handleSave(true)}
                    >
                        Save
                    </Button>
                    <Button
                        color="outline-primary"
                        style={{marginRight: '5px', height: '30px', width: '130px'}}
                        onClick={() => this.handleSave(false)}
                    >
                        Save &amp; Next
                    </Button>
                    <Button
                        color="outline-primary"
                        style={{height: '30px', width: '110px'}}
                        onClick={this.props.closeItemDialog}
                    >
                        Close
                    </Button>
                </div>
            </div>
        );
    }

    renderBarcodeField(item) {
        const disabled = this.isReadOnly();
        return (
            <AvGroup>
                <Label for="barcode">
                    <Translate contentKey="purchaseOrderItem.barcode">Barcode</Translate>
                    {!disabled && requiredMark}
                </Label>
                <div className="settings-page__barcode-input-row">
                    <AvField
                        type="text"
                        name="barcode"
                        id="barcode"
                        innerRef={(el) => (this.barcodeRef = el)}
                        className={`form-control${disabled ? ' purchase-requisition-item-form__input--readonly' : ''}`}
                        value={item.barcode || ''}
                        onChange={this.__handleChange}
                        onKeyDown={this._handleEnterKeyDown}
                        onInput={this._handleEnterInput}
                        autoComplete="off"
                        enterKeyHint="done"
                        disabled={disabled}
                    />
                    {!disabled &&
                        <Button
                            type="button"
                            color="outline-primary"
                            className="settings-page__btn--search"
                            onClick={this.findByBarcode}
                            title="Search"
                        >
                            <i className="pi pi-search" aria-hidden="true"/>
                        </Button>
                    }
                </div>
            </AvGroup>
        );
    }

    renderProductNameField(item, isWeb) {
        const disabled = this.isReadOnly();
        return (
            <AvGroup>
                <Label for="itemName">
                    <Translate contentKey="purchaseOrderItem.itemName">Product Name</Translate>
                    {isWeb && !disabled && requiredMark}
                </Label>
                <AvField
                    type="text"
                    name="itemName"
                    className={disabled ? 'purchase-requisition-item-form__input--readonly' : 'purchase-requisition-item-form__input--editable'}
                    value={item.itemName || ''}
                    onChange={this.__handleChange}
                    disabled={disabled}
                />
            </AvGroup>
        );
    }

    renderSupplierField(item, isWeb) {
        const disabled = this.isReadOnly();
        return (
            <AvGroup>
                <Label for="currentSupplierId">
                    Current Supplier
                    {isWeb && !disabled && requiredMark}
                </Label>
                <AvField
                    type="select"
                    name="supplierId"
                    className={disabled ? 'purchase-requisition-item-form__input--readonly' : ''}
                    value={item.supplierId || item.currentSupplierId || ''}
                    onChange={this.__handleSupplierChange}
                    disabled={disabled}
                >
                    <option value="" key=""/>
                    {(this.state.supplierList || []).map(element => (
                        <option value={element.id} key={element.id}>{element.name}</option>
                    ))}
                </AvField>
            </AvGroup>
        );
    }

    renderCurrentCostField(item) {
        return (
            <AvGroup>
                <Label for="currentCost">
                    Current Cost
                    {this.props.webPopup && item.cheaperCostAvailable && (
                        <span style={{color: '#e81123'}}> (Cheaper option available)</span>
                    )}
                </Label>
                <NumberFormat
                    value={item.currentCost}
                    className={`number-format-input form-control purchase-requisition-item-form__input--readonly${this.props.webPopup && item.cheaperCostAvailable ? ' purchase-requisition-cost-alternatives__input--warning' : ''}`}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={false}
                    disabled={true}
                />
            </AvGroup>
        );
    }

    getActualQtyLabel = () => this.props.deliveryMode ? 'Total Quantity' : 'Actual Order Amount';

    getBoxQuantityLabel = () => 'Units per Box';

    getItemQuantityLabel = () => 'Number of Boxes';

    getDeliveryQuantityLabel = () => 'Total Quantity';

    getDamagedQuantityLabel = () => 'Waste Quantity';

    getNetQuantityLabel = () => 'Net Quantity';

    renderDeliveryBoxVisual = (item) => {
        const boxes = Number(item?.deliveredBoxCount);
        const unitsPerBox = Number(item?.boxSize);
        if (Number.isNaN(boxes) || Number.isNaN(unitsPerBox)
            || item?.deliveredBoxCount === '' || item?.deliveredBoxCount == null
            || item?.boxSize === '' || item?.boxSize == null
            || boxes <= 0 || unitsPerBox <= 0) {
            return (
                <div className="dn-box-visual dn-box-visual--empty">
                    Enter Units per Box and Number of Boxes to preview packing
                </div>
            );
        }

        const boxCount = Math.floor(boxes);
        const perBox = Math.floor(unitsPerBox);
        const total = boxCount * perBox;
        const damagedRaw = Number(item?.damagedQuantity);
        const damagedCount = Number.isNaN(damagedRaw)
            || item?.damagedQuantity === ''
            || item?.damagedQuantity == null
            ? 0
            : Math.max(0, Math.min(Math.floor(damagedRaw), total));
        const netCount = total - damagedCount;

        const maxBoxes = 12;
        const maxUnits = 24;
        const shownBoxes = Math.min(boxCount, maxBoxes);
        const shownUnits = Math.min(perBox, maxUnits);
        const cols = Math.min(6, Math.max(2, Math.ceil(Math.sqrt(shownUnits))));
        const damagedStartIndex = total - damagedCount;

        return (
            <div className="dn-box-visual">
                <div className="dn-box-visual__summary">
                    <strong>{boxCount}</strong> box{boxCount === 1 ? '' : 'es'}
                    <span className="dn-box-visual__times">×</span>
                    <strong>{perBox}</strong> unit{perBox === 1 ? '' : 's'}
                    <span className="dn-box-visual__eq">=</span>
                    <strong>{total}</strong> total
                    {damagedCount > 0 &&
                        <>
                            <span className="dn-box-visual__sep">·</span>
                            <strong className="dn-box-visual__damaged-text">{damagedCount}</strong> waste
                            <span className="dn-box-visual__sep">·</span>
                            <strong>{netCount}</strong> net
                        </>
                    }
                </div>
                <div className="dn-box-visual__legend">
                    <span className="dn-box-visual__legend-item">
                        <span className="dn-box-visual__unit"/> OK
                    </span>
                    <span className="dn-box-visual__legend-item">
                        <span className="dn-box-visual__unit dn-box-visual__unit--damaged"/> Waste
                    </span>
                </div>
                <div className="dn-box-visual__boxes" aria-hidden="true">
                    {Array.from({length: shownBoxes}).map((_, boxIndex) => (
                        <div className="dn-box-visual__box" key={`box-${boxIndex}`}>
                            <div
                                className="dn-box-visual__units"
                                style={{gridTemplateColumns: `repeat(${cols}, 1fr)`}}
                            >
                                {Array.from({length: shownUnits}).map((__, unitIndex) => {
                                    const globalIndex = boxIndex * perBox + unitIndex;
                                    const isDamaged = damagedCount > 0 && globalIndex >= damagedStartIndex;
                                    return (
                                        <span
                                            className={`dn-box-visual__unit${isDamaged ? ' dn-box-visual__unit--damaged' : ''}`}
                                            key={`u-${boxIndex}-${unitIndex}`}
                                        />
                                    );
                                })}
                            </div>
                            <div className="dn-box-visual__box-label">{perBox}</div>
                        </div>
                    ))}
                    {boxCount > maxBoxes &&
                        <div className="dn-box-visual__more">+{boxCount - maxBoxes} more boxes</div>
                    }
                </div>
                {perBox > maxUnits &&
                    <div className="dn-box-visual__note">
                        Showing {maxUnits} of {perBox} units per box
                    </div>
                }
            </div>
        );
    };

    getDeliveryQuantity = (item) => {
        const itemQty = Number(item?.deliveredBoxCount);
        const boxQuantity = Number(item?.boxSize);
        if (Number.isNaN(itemQty) || Number.isNaN(boxQuantity)
            || item?.deliveredBoxCount === '' || item?.deliveredBoxCount == null
            || item?.boxSize === '' || item?.boxSize == null) {
            return null;
        }
        return itemQty * boxQuantity;
    };

    getNetQuantity = (item) => {
        const deliveryQty = this.getDeliveryQuantity(item);
        if (deliveryQty == null) {
            return null;
        }
        const damaged = Number(item?.damagedQuantity);
        const damagedValue = Number.isNaN(damaged) || item?.damagedQuantity === '' || item?.damagedQuantity == null
            ? 0
            : damaged;
        return deliveryQty - damagedValue;
    };

    calculateDeliveryQty = (boxes, boxQty) => {
        const boxCount = Number(boxes);
        const perBox = Number(boxQty);
        if (Number.isNaN(boxCount) || Number.isNaN(perBox) || boxes === '' || boxes == null || boxQty === '' || boxQty == null) {
            return null;
        }
        return boxCount * perBox;
    };

    updateDeliveryCalcFields = (patch) => {
        this.setState(prev => {
            const item = {...prev.item, ...patch};
            const calculated = this.calculateDeliveryQty(item.deliveredBoxCount, item.boxSize);
            if (calculated != null) {
                item.actualOrderAmount = calculated;
            }
            if (Object.prototype.hasOwnProperty.call(patch, 'damagedQuantity')
                && item.damagedQuantity != null
                && String(item.damagedQuantity).trim() !== '') {
                const damagedNumber = Number(item.damagedQuantity);
                const totalQty = calculated != null ? calculated : this.getDeliveryQuantity(item);
                if (!Number.isNaN(damagedNumber) && totalQty != null && damagedNumber > totalQty) {
                    toast.warn('Waste Quantity cannot be greater than Total Quantity');
                    item.damagedQuantity = prev.item.damagedQuantity;
                }
            } else if (calculated != null
                && item.damagedQuantity != null
                && String(item.damagedQuantity).trim() !== '') {
                const damagedNumber = Number(item.damagedQuantity);
                if (!Number.isNaN(damagedNumber) && damagedNumber > calculated) {
                    toast.warn('Waste Quantity cannot be greater than Total Quantity');
                    item.damagedQuantity = null;
                }
            }
            return {item};
        });
    };

    __handleExpiryDateChange = (e) => {
        if (this.isReadOnly()) {
            return;
        }
        const raw = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let expiryDate = null;
        if (raw !== '' && raw != null) {
            const parsed = dayjs(Number(raw));
            expiryDate = parsed.isValid() ? parsed.format('DD/MM/YYYY') : null;
        }
        this.setState(prev => ({
            item: {...prev.item, expiryDate}
        }));
    };

    getExpiryDateInputValue = (item) => {
        if (GeneralUtils.isNullOrEmpty(item?.expiryDate)) {
            return '';
        }
        const parsed = dayjs(item.expiryDate, 'DD/MM/YYYY');
        return parsed.isValid() ? parsed.valueOf() : '';
    };

    renderDeliveryNumberField = (name, label, required = false, onValueChange) => {
        const disabled = this.isReadOnly();
        const readonlyClass = disabled
            ? ' purchase-requisition-item-form__input--readonly'
            : ' purchase-requisition-item-form__input--editable';
        return (
            <AvGroup>
                <Label for={name}>
                    {label}
                    {required && !disabled && requiredMark}
                </Label>
                <NumberFormat
                    value={this.state.item[name]}
                    className={`number-format-input form-control${readonlyClass}`}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={false}
                    onValueChange={(values) => {
                        if (disabled) {
                            return;
                        }
                        if (onValueChange) {
                            onValueChange(values.value);
                            return;
                        }
                        this.setState(prev => ({
                            item: {...prev.item, [name]: values.value}
                        }));
                    }}
                    disabled={disabled}
                />
            </AvGroup>
        );
    };

    renderDeliveryFormBody(item) {
        const deliveryQty = this.getDeliveryQuantity(item);
        const netQty = this.getNetQuantity(item);
        return (
            <div className="purchase-requisition-item-form__grid">
                <div className="purchase-requisition-item-form__section">
                    <div className="purchase-requisition-item-form__section-title">Product</div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderBarcodeField(item)}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--8">
                            <AvGroup>
                                <Label for="itemName">Product Name</Label>
                                <AvField
                                    type="text"
                                    name="itemName"
                                    className="purchase-requisition-item-form__input--readonly"
                                    value={item.itemName || ''}
                                    disabled={true}
                                />
                            </AvGroup>
                        </div>
                    </div>
                </div>

                <div className="purchase-requisition-item-form__section">
                    <div className="purchase-requisition-item-form__section-title">Quantity</div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderDeliveryNumberField(
                                'boxSize',
                                this.getBoxQuantityLabel(),
                                true,
                                (value) => this.updateDeliveryCalcFields({boxSize: value})
                            )}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderDeliveryNumberField(
                                'deliveredBoxCount',
                                this.getItemQuantityLabel(),
                                true,
                                (value) => this.updateDeliveryCalcFields({deliveredBoxCount: value})
                            )}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            <AvGroup>
                                <Label for="deliveryQuantity">{this.getDeliveryQuantityLabel()}</Label>
                                <input
                                    type="text"
                                    className="form-control purchase-requisition-item-form__input--readonly"
                                    value={deliveryQty == null ? '—' : deliveryQty}
                                    disabled={true}
                                    readOnly={true}
                                />
                            </AvGroup>
                        </div>
                    </div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderDeliveryNumberField(
                                'damagedQuantity',
                                this.getDamagedQuantityLabel(),
                                false,
                                (value) => this.updateDeliveryCalcFields({damagedQuantity: value})
                            )}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            <AvGroup>
                                <Label for="netQuantity">{this.getNetQuantityLabel()}</Label>
                                <input
                                    type="text"
                                    className="form-control purchase-requisition-item-form__input--readonly"
                                    value={netQty == null ? '—' : netQty}
                                    disabled={true}
                                    readOnly={true}
                                />
                            </AvGroup>
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            <AvGroup>
                                <Label for="expiryDate">Expiry Date</Label>
                                <DateInput
                                    name="expiryDate"
                                    format="DD/MM/YYYY"
                                    value={this.getExpiryDateInputValue(item)}
                                    onChange={this.__handleExpiryDateChange}
                                    disabled={this.isReadOnly()}
                                />
                            </AvGroup>
                        </div>
                    </div>
                    <div className="purchase-requisition-item-form__hint">
                        Example: Units per Box 6 × Number of Boxes 3 = Total Quantity 18 − Waste 2 → Net Quantity 16
                    </div>
                    {this.props.webPopup === true && this.renderDeliveryBoxVisual(item)}
                </div>
            </div>
        );
    }

    renderWebFormBody(item) {
        const isWeb = true;
        const isDelivery = this.props.deliveryMode === true;
        if (isDelivery) {
            return this.renderDeliveryFormBody(item);
        }
        return (
            <div className="purchase-requisition-item-form__grid">
                <div className="purchase-requisition-item-form__section">
                    <div className="purchase-requisition-item-form__section-title">Identification</div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderBarcodeField(item)}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--8">
                            {this.renderProductNameField(item, isWeb)}
                        </div>
                    </div>
                </div>

                <div className="purchase-requisition-item-form__section">
                    <div className="purchase-requisition-item-form__section-title">Packaging</div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderNumberField('itemSize', 'Item Qty')}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            <AvGroup>
                                <Label for="itemUnitMeasure">Unit</Label>
                                <AvField
                                    type="select"
                                    name="itemUnitMeasure"
                                    className={this.isReadOnly() ? 'purchase-requisition-item-form__input--readonly' : ''}
                                    value={item.itemUnitMeasure || ''}
                                    onChange={this.__handleChange}
                                    disabled={this.isReadOnly()}
                                >
                                    <option value="" key=""/>
                                    {PRODUCT_UNIT.map(element => (
                                        <option value={element.value} key={element.value}>{element.name}</option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderNumberField('boxSize', 'Box Qty')}
                        </div>
                    </div>
                </div>

                <div className="purchase-requisition-item-form__section">
                    <div className="purchase-requisition-item-form__section-title">Supplier &amp; stock</div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                            {this.renderSupplierField(item, isWeb)}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                            {this.renderCurrentCostField(item)}
                        </div>
                    </div>
                    <div className="purchase-requisition-item-form__row">
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderNumberField('currentStock', 'Current Stock', true)}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderNumberField('minStock', 'Min Stock', true)}
                        </div>
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                            {this.renderNumberField('maxStock', 'Max Stock', true)}
                        </div>
                    </div>
                </div>

                <div className="purchase-requisition-item-form__section">
                    <div className="purchase-requisition-item-form__section-title">
                        {isDelivery ? 'Delivery quantity' : 'Order quantity'}
                    </div>
                    <div className="purchase-requisition-item-form__row">
                        {!isDelivery &&
                            <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                                {this.renderNumberField('recommendedOrderAmount', 'Recommended Order Amount', true, false)}
                            </div>
                        }
                        <div className={`purchase-requisition-item-form__cell purchase-requisition-item-form__cell--${isDelivery ? '12' : '6'}`}>
                            {this.renderNumberField('actualOrderAmount', this.getActualQtyLabel(), false, isWeb)}
                        </div>
                    </div>
                </div>

                {this.renderCostAlternatives(item)}
            </div>
        );
    }

    renderFormBody(item) {
        const isWeb = this.props.webPopup === true;
        if (this.props.deliveryMode) {
            return this.renderDeliveryFormBody(item);
        }
        if (isWeb) {
            return this.renderWebFormBody(item);
        }
        return (
            <div className="purchase-requisition-item-form__grid">
                <div className="purchase-requisition-item-form__row">
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                        {this.renderBarcodeField(item)}
                    </div>
                </div>

                <div className="purchase-requisition-item-form__row">
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                        {this.renderProductNameField(item, isWeb)}
                    </div>
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--2">
                        {this.renderNumberField('itemSize', 'Item Qty')}
                    </div>
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--2">
                        <AvGroup>
                            <Label for="itemUnitMeasure">Unit</Label>
                            <AvField
                                type="select"
                                name="itemUnitMeasure"
                                className={this.isReadOnly() ? 'purchase-requisition-item-form__input--readonly' : ''}
                                value={item.itemUnitMeasure || ''}
                                onChange={this.__handleChange}
                                disabled={this.isReadOnly()}
                            >
                                <option value="" key=""/>
                                {PRODUCT_UNIT.map(element => (
                                    <option value={element.value} key={element.value}>{element.name}</option>
                                ))}
                            </AvField>
                        </AvGroup>
                    </div>
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--2">
                        {this.renderNumberField('boxSize', 'Box Qty')}
                    </div>
                </div>

                <div className="purchase-requisition-item-form__row">
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                        {this.renderSupplierField(item, isWeb)}
                    </div>
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                        {this.renderCurrentCostField(item)}
                    </div>
                </div>

                <div className="purchase-requisition-item-form__row">
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                        {this.renderNumberField('currentStock', 'Current Stock', true)}
                    </div>
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                        {this.renderNumberField('minStock', 'Min Stock', true)}
                    </div>
                    <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--4">
                        {this.renderNumberField('maxStock', 'Max Stock', true)}
                    </div>
                </div>

                <div className="purchase-requisition-item-form__row">
                    {!this.props.deliveryMode &&
                        <div className="purchase-requisition-item-form__cell purchase-requisition-item-form__cell--6">
                            {this.renderNumberField('recommendedOrderAmount', 'Recommended Order Amount', true, false)}
                        </div>
                    }
                    <div className={`purchase-requisition-item-form__cell purchase-requisition-item-form__cell--${this.props.deliveryMode ? '12' : '6'}`}>
                        {this.renderNumberField('actualOrderAmount', this.getActualQtyLabel(), false, !this.isReadOnly())}
                    </div>
                </div>

                {this.renderCostAlternatives(item)}
            </div>
        );
    }

    render() {
        const item = this.state.item || {};
        const formBody = this.renderFormBody(item);

        if (this.props.webPopup) {
            return (
                <div className="purchase-requisition-item-form purchase-requisition-item-form--web">
                    {formBody}
                    {this.renderFooter()}
                </div>
            );
        }

        return (
            <div>
                <Fieldset legend="Product">
                    {formBody}
                </Fieldset>
                {this.renderFooter()}
            </div>
        );
    }
}
